@if (data$ | async; as data) {
  <div class="grid grid-cols-2 gap-3">
    <app-details-view label="Nazwa">
      {{ data.name }}
    </app-details-view>

    <app-details-view label="Kategoria">
      {{ data.category }}
    </app-details-view>

    <app-details-view label="Data utworzenia">
      <app-date-time [date]="data.createdAt" />
    </app-details-view>

    <div class="col-span-2">
      <app-details-view label="Opis">
        <app-summernote-html-preview [html]="data.description" />
      </app-details-view>
    </div>

    <div class="col-span-2">
      <app-details-view label="Szczegóły cennika metody wysyłki">
        @if (shouldShowPrices(data.prices)) {
          <div class="rounded-lg border border-gray-200 p-4">
            <p-accordion [multiple]="true">
              @for (price of data.prices; track price.id; let index = $index) {
                <p-accordion-panel [value]="index">
                  <p-accordion-header>
                    <div class="flex items-center gap-2 text-sm text-gray-400">
                      <span>#{{ index + 1 }}</span>
                      <span>{{ price.country.label }}</span>
                    </div>
                  </p-accordion-header>

                  <p-accordion-content>
                    <div class="grid grid-cols-2 gap-3">
                      <app-details-view label="Kwota">
                        <app-currency [amount]="price.price" />
                      </app-details-view>

                      <app-details-view label="Metody płatności">
                        @for (
                          method of price.paymentMethods;
                          track method.id;
                          let isLast = $last
                        ) {
                          <div class="inline-flex">
                            <span>{{ method.name }}</span>

                            @if (!isLast) {
                              <span class="mr-1">,</span>
                            }
                          </div>
                        }
                      </app-details-view>
                    </div>
                  </p-accordion-content>
                </p-accordion-panel>
              }
            </p-accordion>
          </div>
        } @else {
          <app-no-data />
        }
      </app-details-view>
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
